module.exports = __webpack_public_path__ + "static/media/logo-external-retina.f379b4b6.png";